import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/system';


function AverageCostChip({ draft, isSmall = false}) {
    const theme = useTheme();

    const diffToAverageCost = Math.round(((draft.total_card_spend - draft.average_procedure_card_spend) / draft.average_procedure_card_spend) * 100);

    if (diffToAverageCost > 0) {
        return (
            <Box py={0.5} px={1} sx={{ color: `${theme.palette.red.main}`, backgroundColor: `${theme.palette.background.negative}`, borderRadius: '4px', fontSize: '10px' }}>
                <Typography variant='heavy'>
                    {diffToAverageCost}% Above {isSmall ? 'Avg' : 'Average'}
                </Typography>
            </Box>
        );
    } else if (diffToAverageCost < 0) {
        return (
            <Box py={0.5} px={1} sx={{ color: `${theme.palette.blue.main}`, backgroundColor: `${theme.palette.background.positive}`, borderRadius: '4px', fontSize: '10px' }}>
                <Typography variant='heavy'>
                    {Math.abs(diffToAverageCost)}% Below {isSmall ? 'Avg' : 'Average'}
                </Typography>
            </Box>
        );
    }
    return <></>;
}

export default AverageCostChip;
